import React, { Fragment } from "react";
import { MuiPickersUtilsProvider, KeyboardTimePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { useForm, Controller } from "react-hook-form";
import { TextField, FormHelperText, Button } from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { useState } from "react";
import api from "../../../store/api";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import { consts } from "../../../common/consts";
import submitData from "../submitData";
import { format } from "date-fns";
import { useHistory } from "react-router-dom";
const spinnerImage = require("../../../assets/images/Spinner.gif");

interface ILocationWeeklyWorkingHours {
  name: string | null;
  locationId: string | null;
  pickupLeadTime: number | null;
  dropoffLeadTime: number | null;
  workingHours: { [index: string]: IWorkingHour };
}
interface IWorkingHour {
  open: boolean;
  from: string | null;
  to: string | null;
}

interface WeekDate {
  name: string;
  date: string;
  holiday: boolean;
  holidayName: string | null;
}

interface Holiday {
  name: string;
  date: string;
}

interface PickUpDropOff {
  bookingDate: string;
  anyTimeOfTheDay?: boolean;
  pickupBeforeTime?: any;
  pickupAfterTime?: any;
  dropoffBeforeTime?: any;
  dropoffAfterTime?: any;
  scheduledDate?: any;
  reasonForThisTime?: any;
  otherReasonDetails?: string | null;
  priority?: number;
}

const useStyles = makeStyles((theme) => ({
  formControlLabel: {
    fontSize: 18,
    color: "#4A4A4A",
    padding: theme.spacing(0, 0, 1, 0),
  },
  helpText: {
    color: "red",
    padding: theme.spacing(0, 0, 0, 2),
  },
  estimatingDuration: {
    backgroundColor: "#333",
    borderRadius: 4,
    padding: 4,
    boxSizing: "border-box",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    marginTop: 10,
  },
  estimatedDuration: {
    backgroundColor: "#333",
    borderRadius: 4,
    padding: 12,
    boxSizing: "border-box",
    color: "#fff",
    marginTop: 10,
  },
  spinner: {
    height: 35,
  },
}));

const weekDay = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

const parseTime = (time: any): any | null => {
  if (typeof time === "string") return time;
  let d = new Date();
  if (time && time.value) {
    // not sure if it is still applicable
    d.setHours(time.value.hours);
    d.setMinutes(time.value.minutes);
  }else if(time && (time.hours || time.minutes)) {
    d.setHours(time.hours);
    d.setMinutes(time.minutes);
  }
  else return null;
  return d;
};

const PickDropTime = ({ NextButton, handleData, data, saveChangesState, isEdit, dispatch, existsOnPlanner }: any) => {
  const dateUtils = new DateFnsUtils();
  const { authStore } = useSelector((state: RootState) => state);
  const [sheduleDate, setSheduleDate] = useState<MaterialUiPickersDate>(
    data.scheduledDate ? dateUtils.parse(data.scheduledDate, "yyyy-MM-dd'T'HH:mm:ss") : null
  );

  const [afterDate, setAfterDate] = useState<MaterialUiPickersDate>(
    data.pickupAfterTime
      ? parseTime(data.pickupAfterTime)
      : data.dropoffAfterTime
      ? parseTime(data.dropoffAfterTime)
      : null
  );
  const [beforeDate, setBeforeDate] = useState<MaterialUiPickersDate>(
    data.pickupBeforeTime
      ? parseTime(data.pickupBeforeTime)
      : data.dropoffBeforeTime
      ? parseTime(data.dropoffBeforeTime)
      : null
  );
  const { handleSubmit, errors, control, setValue, clearErrors, setError, trigger, getValues } = useForm();
  const classes = useStyles();
  const [days, setDays] = useState<WeekDate[]>([]);
  const [publicHolidays, setPublicHoliDays] = useState<WeekDate[]>([]);
  const [selectDay, setSelectDay] = useState<string>("");
  const [type, setType] = useState("Pickup");
  const [reason, setReason] = useState("");
  const [priority, setPriority] = useState(3);
  const [userType, setUserType] = useState(1);
  const [timeValidationNormal, setTimeValidationNormal] = useState(false);
  const [timeValidationAdmin, setTimeValidationAdmin] = useState(0);
  const [otherReasonText, setOtherReasonText] = useState("");
  const [myLocationWeeklyWorkingHours, setLocationWeeklyWorkingHours] = useState<ILocationWeeklyWorkingHours>();
  const [originDestinationWeeklyWorkingHours, setOriginDestinationWeeklyWorkingHours] = useState<ILocationWeeklyWorkingHours>();
  // const [estimatorLoading, setEstimatorLoading] = useState(0);
  // const [estimatedTripDuration, setEstimatedTripDuration] = useState('');
  const history = useHistory();

  setValue("type", "Pickup");
  setValue("priority", 3);

  const handleNext = async (data: any): Promise<void> => {
    handleData(data);
  };

  const onNextButtonClick = async (): Promise<boolean> => {
    const isValid = await trigger();
    if (isValid) {
      let passData = getValuesByUserType();
      if (passData != false && passData != {}) {
        await handleNext(passData);
      } else {
        return !isValid;
      }
    }
    return isValid;
  };

  const isAdmin = async (): Promise<void> => {
    if (authStore.data?.IsAdmin || authStore?.data?.role?.split(",")?.some((p) => p == consts.Permissions.SMAScheduleTransfer)) {
      setUserType(1);
    } else setUserType(0);
  };

  const getLocationWeeklyWorkingHours = async (locationId: string): Promise<void> => {
    try {
      const _res = await api.getLocationWeeklyWorkingHours("locationId=" + locationId);
      const weeklyWorkingHours = _res.data.model as ILocationWeeklyWorkingHours;
      setOriginDestinationWeeklyWorkingHours(weeklyWorkingHours);
    } catch (error) {}
  };

  const getMyLocationWeeklyWorkingHours = async (): Promise<void> => {
    try {
      const res = await api.getMyLocationWeeklyWorkingHours("");
      const weeklyWorkingHours = res.data.model as ILocationWeeklyWorkingHours;
      setLocationWeeklyWorkingHours(weeklyWorkingHours);

      let _tempDate = new Date();
      const publicHolidayRes = await api.GetPublicHolidayList("locationId="+(data.patientOfLocation ? data.patientOfLocation :"00000000-0000-0000-0000-000000000000"));
      let publicHolidays: Holiday[] = [];
      let publicHolidayDates: string[] = [];
      if (publicHolidayRes.message=="Success"){
        for (let holiday = 0; publicHolidays.length <= publicHolidayRes.model.length-1; holiday++) {
          let holidayInfo: Holiday={
            name: publicHolidayRes.model[holiday].holidayName,
            date: publicHolidayRes.model[holiday].holidayOn.split("T")[0]
          }
          publicHolidays.push(holidayInfo);
          publicHolidayDates.push(holidayInfo.date);
        }
      }
      let dates: WeekDate[] = [];
      for (let date = 0; dates.length <= 6; date++) {
        let datebody: WeekDate = {
          name: date === 0 ? "Today" : date === 1 ? "Tomorrow" : weekDay[_tempDate.getDay()],
          date: dateUtils.format(_tempDate, "yyyy-MM-dd"),
          holiday: publicHolidayDates.length==0 ? false : publicHolidayDates.includes(dateUtils.format(_tempDate, "yyyy-MM-dd")) ? true:false,
          holidayName:publicHolidayDates.length==0 ? null : publicHolidayDates.includes(dateUtils.format(_tempDate, "yyyy-MM-dd")) ? publicHolidays.filter(h => h.date==dateUtils.format(_tempDate, "yyyy-MM-dd"))[0].name:null,
        };
        if (weeklyWorkingHours.workingHours[weekDay[_tempDate.getDay()]] && weeklyWorkingHours.workingHours[weekDay[_tempDate.getDay()]].open) {
          dates.push(datebody);
        }
        _tempDate.setDate(_tempDate.getDate() + 1);
      }
      setDays(dates);
      var today = dates.find((d) => d.name == "Today");
      if (today && today.date && !data.bookingDate && !data.scheduledDate && !today.holiday) {
        setValue("day", today.date);
        setSelectDay(today.date);
      }
    } catch (error) {}
  };

  React.useEffect(() => {
    isAdmin();
    getMyLocationWeeklyWorkingHours();
    if (data && data.originCustomerLocationId) getLocationWeeklyWorkingHours(data.originCustomerLocationId);
    else if (data && data.destinationCustomerLocationId) getLocationWeeklyWorkingHours(data.destinationCustomerLocationId);
  
    let receive: PickUpDropOff = data;

    if (receive.bookingDate) {
      setValue("day", data.bookingDate ? data.bookingDate.split("T")[0] : "");
      setSelectDay(data.bookingDate ? data.bookingDate.split("T")[0] : "");
    }

    if (receive.scheduledDate) {
      let schDate = dateUtils.parse(receive.scheduledDate, "yyyy-MM-dd'T'HH:mm:ss");
      setSheduleDate(schDate);
      setSelectDay(dateUtils.format(schDate, "yyyy-MM-dd"));
    }

    if (receive.pickupAfterTime || receive.pickupBeforeTime) {
      setAfterDate(parseTime(receive.pickupAfterTime));
      setBeforeDate(parseTime(receive.pickupBeforeTime));
      setType("Pickup");
      setValue("type", "Pickup");
    }

    if (receive.dropoffAfterTime || receive.dropoffBeforeTime) {
      setBeforeDate(parseTime(receive.dropoffBeforeTime));
      setAfterDate(parseTime(receive.dropoffAfterTime));
      setType("Dropoff");
      setValue("type", "Dropoff");
    }

    if (receive.anyTimeOfTheDay === true) setType("Any time of day");

    setValue("priority", data.priority ? data.priority : 3);

    setPriority(data.priority ? data.priority : 3);

    setValue("otherreason", receive.otherReasonDetails);
    setOtherReasonText(receive.otherReasonDetails ?? "");

    setValue("reason", receive.reasonForThisTime?.toString() ?? "");
    setReason(receive.reasonForThisTime?.toString() ?? "");
  }, [data]);

  const saveChanges = async (update = false): Promise<boolean> => {
    const isValid = await trigger();
    if (isValid) {
      let passData = getValuesByUserType();
      if (passData != false && passData != {}) {
        if (update == true) submitData({ ...data, ...passData }, dispatch, history);
      } else {
        return !isValid;
      }
    }
    return isValid;
  };

  const parseTimeDataSend = (time: any): any | null => {
    if (typeof time === "string") return time;
    let d = new Date();
    if (time?.getTime()) {
      d.setHours(time.getHours());
      d.setMinutes(time.getMinutes());
    } else return null;
    return d.toISOString();
  };

  React.useEffect(() => {
    saveChangesState[1](() => saveChanges);
  }, [data]);

  const adminDateCheck = () => {};

  const getValuesByUserType = () => {
    const afterTime = parseTimeDataSend(afterDate);
    const beforeTime = parseTimeDataSend(beforeDate);
    const valueForUser: PickUpDropOff = {
      bookingDate: selectDay,
      anyTimeOfTheDay: type === "Any time of day" ? true : false,
      pickupBeforeTime: type === "Pickup" ? beforeTime : "",
      pickupAfterTime: type === "Pickup" ? afterTime : "",
      dropoffBeforeTime: type === "Dropoff" ? beforeTime : "",
      dropoffAfterTime: type === "Dropoff" ? afterTime : "",
      reasonForThisTime: reason,
      otherReasonDetails: otherReasonText,
      scheduledDate: null,
    };
    if ((afterTime || beforeTime || type === "Any time of day")&&valueForUser.bookingDate!="") {
      if (userType === 1) {
        setTimeValidationAdmin(0);
        valueForUser.priority = priority;
      }
      return valueForUser;
    } else {
      userType === 0 ? setTimeValidationNormal(true) : setTimeValidationAdmin(1);
      return false;
    }
    return {};
  };

  const concatTimeDate = (date: Date, time: MaterialUiPickersDate) => {
    let dateUtils = new DateFnsUtils();
    let concatDate = "";
    if (date?.getTime() && time?.getTime()) {
      concatDate = dateUtils.format(date, "yyyy-MM-dd") + "T" + dateUtils.format(time, "HH:mm:ss");
      return concatDate;
    } else return undefined;
  };

  // const estimateTripTime = async () => {
  //     let combinedDateTime = concatTimeDate(dateUtils.parse(selectDay, "yyyy-MM-dd"), sheduleDate);
  //     console.log("combinedDateTime", combinedDateTime);
  //     if(!combinedDateTime) return;
  //     setEstimatorLoading(1);
  //     const _req = {
  //         numberOfClinicalStaff: 1,
  //         transferId: data.transferId,
  //         startDateTime: combinedDateTime,
  //     };
  //     api.calculateTransferDuration('', _req)
  //     .then(res => {
  //         if(res.hasError !== true && res.tripDuration) {
  //             const hours = Math.floor(res.tripDuration / 60);
  //             const minutes = res.tripDuration % 60;
  //             setEstimatedTripDuration(`${hours <= 0 ? '' : `${hours} hour${hours > 1 ? "s" : ""}`} ${minutes} minute${minutes > 1 ? "s" : ""}`);
  //         }
  //         if(res.hasError) {
  //             setEstimatedTripDuration('Not available');
  //         }
  //         setEstimatorLoading(2);
  //     }).catch(() => {
  //         setEstimatedTripDuration('Not available');
  //         setEstimatorLoading(2);
  //     })
  // }

  // React.useEffect(() => {
  //     estimateTripTime();
  // }, [selectDay, sheduleDate])

  const setTimeValue = (type: string, date: MaterialUiPickersDate, value: string | undefined): void => {
    switch (type) {
      case "shedule":
        setSheduleDate(date);
        break;
      case "before":
        setBeforeDate(date);
        break;
      case "after":
        setAfterDate(date);
        break;
      default:
        break;
    }
    setTimeValidationAdmin(0);
    setTimeValidationNormal(false);
  };
  const getNoteHoursOfService = (dateString: string): string => {
    let dateUtils = new DateFnsUtils();

    if (dateUtils.parse(dateString, "yyyy-MM-dd")) {
      let date = dateUtils.parse(dateString, "yyyy-MM-dd");
      if (originDestinationWeeklyWorkingHours && originDestinationWeeklyWorkingHours.workingHours[weekDay[date.getDay()]]) {
        if (
          originDestinationWeeklyWorkingHours.workingHours[weekDay[date.getDay()]].open &&
          originDestinationWeeklyWorkingHours.workingHours[weekDay[date.getDay()]].from
        ) {
          return (
            "Note: Hours of service are between " +
            originDestinationWeeklyWorkingHours.workingHours[weekDay[date.getDay()]].from +
            " to " +
            originDestinationWeeklyWorkingHours.workingHours[weekDay[date.getDay()]].to
          );
        } else if (!originDestinationWeeklyWorkingHours.workingHours[weekDay[date.getDay()]].open) {
          return "Note: Selected day does not have any hour of service";
        }
      }
    }
    return "";
  };

  const validateLeadTime = (before: MaterialUiPickersDate, bookingDate: string, type: string) => {
    let dateUtils = new DateFnsUtils();
    let _tempDate = new Date();
    let today = dateUtils.format(_tempDate, "yyyy-MM-dd");

    if (isEdit === false && bookingDate === today && before !== null) {
      let diffInMilliSeconds = before.getTime() - _tempDate.getTime();
      let diffInMinutes = diffInMilliSeconds / 1000 / 60;
      if (type === "Pickup") {
        if (myLocationWeeklyWorkingHours && myLocationWeeklyWorkingHours.pickupLeadTime) {
          if (diffInMinutes < myLocationWeeklyWorkingHours.pickupLeadTime) {
            setError("before", { message: "Pickup lead time must be minimum " + myLocationWeeklyWorkingHours.pickupLeadTime + " minutes" });
            return;
          }
        }
      } else if (type === "Dropoff") {
        if (myLocationWeeklyWorkingHours && myLocationWeeklyWorkingHours.dropoffLeadTime) {
          if (diffInMinutes < myLocationWeeklyWorkingHours.dropoffLeadTime) {
            setError("before", { message: "Dropoff lead time must be minimum " + myLocationWeeklyWorkingHours.dropoffLeadTime + " minutes" });
            return;
          }
        }
      }
    }
    clearErrors("before");
  };
  return (
    <React.Fragment>
      <form onSubmit={handleSubmit(handleNext)} autoComplete="off" id="patientDetailsForm">
        <Grid style={{ paddingTop: 40 }}>
          <Grid container spacing={3} alignItems="flex-start">
            <Grid item xs={6}>
              <Typography style={{ fontSize: 36, fontWeight: 900 }}>Pickup/Dropoff Time</Typography>
            </Grid>
            <Grid item xs={6} style={{ textAlign: "right" }}>
              {!isEdit && <NextButton onClick={onNextButtonClick} />}
              <Button id="update_changes" style={{ display: "none" }} onClick={() => saveChanges(true)}></Button>
              <Button id="save_changes" style={{ display: "none" }} onClick={() => saveChanges(false)}></Button>
            </Grid>

            <Grid container alignItems="flex-start" style={{ paddingLeft: 10 }}>
              <Grid item xs={12}>
                <Controller
                  render={(props) => (
                    <RadioGroup row aria-label="position" name="inviteUser" defaultValue="top">
                      {days.map((day, index) => {
                        return (
                          <FormControlLabel
                            key={day.date + index}
                            value={day.date}
                            onChange={(e) => {
                              setValue("day", day.date);
                              setSelectDay(day.date);
                              props.onChange(e);
                              validateLeadTime(beforeDate, day.date, type);
                              if (timeValidationAdmin === 2) {
                                setTimeValidationAdmin(0);
                              }
                            }}
                            checked={day.date === selectDay ? true : false}
                            control={<Radio color="primary" />}
                            label={day.holiday? day.name + " ("+day.holidayName+")" : day.name}
                            disabled={day.holiday}
                          />
                        );
                      })}
                    </RadioGroup>
                  )}
                  name="day"
                  control={control}
                  defaultValue=""
                />
                <FormHelperText className={classes.helpText}>{errors.day ? errors.day.message : ""}</FormHelperText>
              </Grid>
            </Grid>
            <Grid container alignItems="flex-start" style={{ paddingLeft: 10 }}>
              <Grid style={{ marginTop: 5 }} container alignItems="flex-start">
                <Grid item xs={12}>
                  <div>
                    Set time limits based on pickup time OR dropoff time. If you are flexible with the time for the pickup please select Any time of
                    day
                  </div>
                </Grid>
              </Grid>

              <Grid container alignItems="flex-start">
                <Grid style={{ marginTop: 5 }} item xs={12}>
                  <Controller
                    render={(props) => (
                      <RadioGroup row aria-label="position" name="inviteUser" defaultValue="top">
                        <FormControlLabel
                          value="Pickup"
                          onChange={(e) => {
                            setType("Pickup");
                            props.onChange(e);
                            validateLeadTime(beforeDate, selectDay, "Pickup");
                          }}
                          checked={type === "Pickup" ? true : false}
                          control={<Radio color="primary" />}
                          label="Pickup"
                          disabled={existsOnPlanner}
                        />
                        <FormControlLabel
                          style={{ marginLeft: 20 }}
                          value="Dropoff"
                          onChange={(e) => {
                            setType("Dropoff");
                            props.onChange(e);
                            validateLeadTime(beforeDate, selectDay, "Dropoff");
                          }}
                          checked={type === "Dropoff" ? true : false}
                          control={<Radio color="primary" />}
                          label="Dropoff"
                          disabled={existsOnPlanner}
                        />
                        <FormControlLabel
                          style={{ marginLeft: 20 }}
                          value="Any time of day"
                          onChange={(e) => {
                            setType("Any time of day");
                            props.onChange(e);
                            validateLeadTime(beforeDate, selectDay, "Any time of day");
                          }}
                          checked={type === "Any time of day" ? true : false}
                          control={<Radio color="primary" />}
                          label="Any time of day"
                          disabled={existsOnPlanner}
                        />
                      </RadioGroup>
                    )}
                    name="type"
                    control={control}
                    defaultValue=""
                  />
                  <FormHelperText className={classes.helpText}>{errors.type ? errors.type.message : ""}</FormHelperText>
                </Grid>
              </Grid>

              <div>
                {type != "Any time of day" ? (
                  <Grid container alignItems="flex-start" spacing={3}>
                    <Grid container item xs={3}>
                      <div style={{ color: "#919191", fontSize: 15, marginTop: 5, marginBottom: 10 }}>AFTER</div>
                      <Fragment>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardTimePicker
                            placeholder="16:00"
                            ampm={false}
                            inputVariant="outlined"
                            invalidDateMessage="Invalid Time"
                            value={afterDate}
                            mask="__:__"
                            InputAdornmentProps={{
                              style: { display: "none" },
                            }}
                            inputProps={{ style: { textAlign: "center", borderColor: "#ECECEC" } }}
                            onChange={(date, value: any) => {
                              setTimeValue("after", date, value);
                            }}
                            disabled={existsOnPlanner}
                          />
                        </MuiPickersUtilsProvider>
                      </Fragment>
                      <FormHelperText className={classes.helpText}>{timeValidationNormal ? "Time is required" : ""}</FormHelperText>
                    </Grid>

                    <Grid container item xs={3}>
                      <div style={{ color: "#919191", fontSize: 15, marginTop: 5, marginBottom: 10 }}>BEFORE</div>
                      <Fragment>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardTimePicker
                            placeholder="16:00"
                            ampm={false}
                            inputVariant="outlined"
                            invalidDateMessage="Invalid Time"
                            value={beforeDate}
                            mask="__:__"
                            InputAdornmentProps={{
                              style: { display: "none" },
                            }}
                            inputProps={{ style: { textAlign: "center", borderColor: "#ECECEC" } }}
                            onChange={(date, value: any) => {
                              validateLeadTime(date, selectDay, type);
                              setTimeValue("before", date, value);
                            }}
                            disabled={existsOnPlanner}
                          />
                        </MuiPickersUtilsProvider>
                      </Fragment>
                      <FormHelperText className={classes.helpText}>{errors.before ? errors.before.message : ""}</FormHelperText>
                    </Grid>
                    <Grid item xs={6}>
                      <div style={{ paddingTop: 40, marginLeft: 10 }}></div>
                    </Grid>
                  </Grid>
                ) : null}
              </div>

              <Grid style={{ marginTop: 25 }} container alignItems="flex-start">
                <div style={{ color: "#919191", fontSize: 15, marginTop: 5, marginBottom: 10 }}>REASON THIS TIME IS REQUIRED</div>
                <Grid item xs={12}>
                  <Controller
                    render={(props) => (
                      <RadioGroup aria-label="position" name="inviteUser" defaultValue="top">
                        <FormControlLabel
                          value="1"
                          onChange={(e) => {
                            setReason("1");
                            props.onChange(e);
                          }}
                          checked={reason === "1" ? true : false}
                          control={<Radio style={{ padding: 0, paddingLeft: 5 }} color="primary" />}
                          label="Patient has an appointment"
                          disabled={existsOnPlanner}
                        />
                        <FormControlLabel
                          value="2"
                          onChange={(e) => {
                            setReason("2");
                            props.onChange(e);
                          }}
                          checked={reason === "2" ? true : false}
                          control={<Radio style={{ padding: 0, paddingLeft: 5 }} color="primary" />}
                          label="Patient has an all-day appointment (needs morning transfer)"
                          disabled={existsOnPlanner}
                        />
                        <FormControlLabel
                          value="3"
                          onChange={(e) => {
                            setReason("3");
                            props.onChange(e);
                          }}
                          checked={reason === "3" ? true : false}
                          control={<Radio style={{ padding: 0, paddingLeft: 5 }} color="primary" />}
                          label="Patient being discharged and their bed is needed"
                          disabled={existsOnPlanner}
                        />
                        <FormControlLabel
                          value="4"
                          onChange={(e) => {
                            setReason("4");
                            props.onChange(e);
                          }}
                          checked={reason === "4" ? true : false}
                          control={<Radio style={{ padding: 0, paddingLeft: 5 }} color="primary" />}
                          label="Bed not available at destination until this time"
                          disabled={existsOnPlanner}
                        />
                        <FormControlLabel
                          value="5"
                          onChange={(e) => {
                            setReason("5");
                            props.onChange(e);
                          }}
                          checked={reason === "5" ? true : false}
                          control={<Radio style={{ padding: 0, paddingLeft: 5 }} color="primary" />}
                          label="Other reason"
                          disabled={existsOnPlanner}
                        />
                      </RadioGroup>
                    )}
                    rules={
                      userType === 0 && type !== "Any time of day"
                        ? {
                            validate: () => {
                              if (reason) return true;
                              else return false;
                            },
                          }
                        : {}
                    }
                    name="reason"
                    control={control}
                    defaultValue=""
                  />
                  <FormHelperText className={classes.helpText}>{errors.reason ? "Reason is required" : ""}</FormHelperText>
                </Grid>
              </Grid>
              {reason === "5" ? (
                <Grid item xs={4} style={{ marginLeft: 20 }}>
                  <Controller
                    name="otherreason"
                    defaultValue=""
                    control={control}
                    render={(props) => (
                      <TextField
                        key="otherreason"
                        onChange={(e) => {
                          setValue("otherreason", e.target.value);
                          setOtherReasonText(e.target.value);
                          props.onChange(e);
                        }}
                        value={otherReasonText}
                        variant="outlined"
                        error={errors.otherreason}
                        helperText={errors.otherreason ? "Other reason is required" : ""}
                        disabled={existsOnPlanner}
                      />
                    )}
                    rules={
                      userType === 0
                        ? {
                            validate: (value) => {
                              if (otherReasonText) return true;
                              else return false;
                            },
                          }
                        : {}
                    }
                  />
                </Grid>
              ) : null}
            </Grid>
            {userType === 1 && (
              <Grid container alignItems="flex-start">
                <div style={{ color: "#919191", fontSize: 15, marginTop: 15, fontWeight: "bold" }}>PRIORITY</div>
                <Grid style={{ marginTop: 5 }} item xs={12}>
                  <Controller
                    render={(props) => (
                      <RadioGroup row aria-label="position" name="inviteUser" defaultValue="top">
                        <FormControlLabel
                          value="3"
                          onChange={(e) => {
                            setPriority(3);
                            setValue("priority", 3);
                            props.onChange(e);
                          }}
                          checked={priority === 3 ? true : false}
                          control={<Radio color="primary" />}
                          label="Priority 3"
                        />
                        <FormControlLabel
                          style={{ marginLeft: 20 }}
                          value="2"
                          onChange={(e) => {
                            setPriority(2);
                            setValue("priority", 2);
                            props.onChange(e);
                          }}
                          checked={priority === 2 ? true : false}
                          control={<Radio color="primary" />}
                          label="Priority 2"
                        />
                        <FormControlLabel
                          style={{ marginLeft: 20 }}
                          value="1"
                          onChange={(e) => {
                            setPriority(1);
                            setValue("priority", "1");
                            props.onChange(e);
                          }}
                          checked={priority === 1 ? true : false}
                          control={<Radio color="primary" />}
                          label="Priority 1"
                        />
                      </RadioGroup>
                    )}
                    name="priority"
                    control={control}
                    defaultValue=""
                  />
                  <FormHelperText className={classes.helpText}>{errors.priority ? errors.priority.message : ""}</FormHelperText>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
      </form>
    </React.Fragment>
  );
};

export default PickDropTime;
